import { call, put, delay, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/models/runTraining';
import { getModelDetail } from '../../actions/models/detail';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  const { modelId } = action?.payload || {};
  try {
    const response = yield call(
      axios.post,
      `${config.API_URL}/pipelines/${modelId}/train`,
      {},
      {
        headers: {
          ...getLocalUser(),
          'X-Workspace-Id': localStorage.getItem('WORKSPACE_ID') || '',
        },
      },
    );
    yield put(fetchSuccess(response?.data?.data ?? response?.data ?? {}));
    // Give the backend a beat to register the queued run, then refresh
    // the pipeline detail so the in-training indicator appears
    // (mirrors the component's previous 1200ms follow-up).
    yield delay(1200);
    yield put(getModelDetail(modelId));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
